import { action } from 'satcheljs';
import type { AccountMailboxType } from 'owa-graph-schema';

export default action(
    'authAndAddAccount',
    (emailAddress: string, accountType: AccountMailboxType) => ({
        emailAddress: emailAddress,
        accountType: accountType,
    })
);
